// 手機攝影機額度（ls-loop MW；F08 ⓪「手機攝影機額度」與「雲端錄影台數」分開顯示，對齊 Android 方案頁「用量」）。
// GET /v3/me/phone-cameras/quota → {used, limit, free, devices[{device_id, name, suspended, joined_at}]}
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiFetch } from '../../lib/api';

interface QuotaDevice { device_id: string; name: string; suspended: boolean; joined_at: number }
interface Quota { used: number; limit: number; free: number; devices: QuotaDevice[] }

export function PhoneCamQuotaCard() {
  const { t } = useTranslation();
  const [q, setQ] = useState<Quota | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    apiFetch<Quota>('/v3/me/phone-cameras/quota')
      .then((r) => { if (alive) setQ(r.data); })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, []);
  if (failed) return null; // 沒有這個端點（主線雲端）→ 不顯示
  return (
    <section className="card" data-testid="phonecam-quota" style={{ display: 'grid', gap: 'var(--spacing-3)' }}>
      <h2 style={{ margin: 0, fontSize: 'var(--font-size-lg)' }}>{t('phonecam.quotaTitle')}</h2>
      {!q ? (
        <span className="text-secondary">…</span>
      ) : (
        <>
          <span>{t('phonecam.quotaUsage', { used: q.used, limit: q.limit, free: q.free })}</span>
          {q.devices.length === 0 ? (
            <span className="text-secondary">{t('phonecam.quotaNone')}</span>
          ) : (
            <ul style={{ margin: 0, paddingLeft: '1.2em' }}>
              {q.devices.map((d) => (
                <li key={d.device_id}>
                  {d.name || d.device_id}
                  {d.suspended && <span className="text-danger"> — {t('phonecam.quotaSuspended')}</span>}
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </section>
  );
}
